import { z } from "zod";

import type { VariableDesign as ActualVariableDesign } from "../types/index.ts";

// NOTE: no type exports because zod won't let you express a union within a discriminated union
// This is limiting in several ways:
// 1. Not validating that it is either a reference or concrete.
// 2. Both initialValue and refId are optional where in the types you have to have or the other at a minimum

const DesignBase = z.object({
  id: z.number(),
});

const ReferenceBase = z.object({ refId: z.number().optional() });

const ConcreteBase = z.object({ scopeToNodeId: z.number().optional() });

const NumberVariableDesign = DesignBase.extend({
  type: z.literal("number"),
}).merge(ConcreteBase.extend({ initialValue: z.number().optional() }).merge(ReferenceBase));

const StringVariableDesign = DesignBase.extend({
  type: z.literal("string"),
}).merge(ConcreteBase.extend({ initialValue: z.string().optional() }).merge(ReferenceBase));

const BooleanVariableDesign = DesignBase.extend({
  type: z.literal("boolean"),
}).merge(ConcreteBase.extend({ initialValue: z.boolean().optional() }).merge(ReferenceBase));

export const VariableDesign = z.discriminatedUnion("type", [
  NumberVariableDesign,
  StringVariableDesign,
  BooleanVariableDesign,
]);

// have to coerce as it doesn't actually match. see comment at top
export const VariableDesigns = z.record(VariableDesign) as z.ZodType<Record<string, ActualVariableDesign>>;
